import UserSurveyRewardLocation from './UserSurveyRewardLocation';

export default UserSurveyRewardLocation;



// WEBPACK FOOTER //
// ./src/components/userSurveyReward/index.js